import { useState, useCallback } from 'react';
import { achievementService } from '../services/achievementService';

export const useUserTitle = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateTitle = useCallback(async (userId) => {
    if (!userId) {
      setError('User ID is required');
      return null;
    }

    setLoading(true);
    setError(null);

    try {
      const result = await achievementService.updateUserTitle(userId);
      
      if (result?.success) {
        return result;
      } else {
        setError(result?.message || 'Failed to update title');
        return null;
      }
    } catch (err) {
      console.error('Error updating user title:', err);
      setError(err.message || 'An error occurred while updating title');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    updateTitle,
    loading,
    error
  };
};